module.exports = __webpack_public_path__ + "img/eu.2d7eeed9.svg";